import React from "react";
import { Link } from "react-router-dom";
import "./aboutUsBottomPage.css";
const AboutUsBottomPage = () => {
  return (
    <div>
      <div className="aboutUsBottom-page-wrapper">
        {" "}
        <div className="" id="aboutUsBottomPage">
          <div
            className="contact_investers_wrapper text-center"
            style={{ backgroundImage: " url('../../assets/bg-pattern.svg');" }}
          >
            <div
              className="position-relative right-side-width"
              style={{ gap: "15px" }}
            >
              <h4 className="title_text">The Strength of our team</h4>
              <p className="contact_investers_para">
                At Soori Corporation, our most valuable asset is our people. Our
                team is composed of highly skilled professionals who are experts
                in their fields. From software development and project
                management to customer support, each member is dedicated to
                understanding and addressing your unique business needs. Their
                deep expertise and commitment to excellence allow us to build
                strong, lasting partnerships with our clients. By leveraging
                their extensive experience, we deliver tailored solutions that
                drive meaningful success and growth.
              </p>
              <Link to="/connect-with-us" className="btn-md btn-dark border-0">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsBottomPage;
